export var exchangeRates = {
	AT: null,
	BE: null,
	BG: null,
	CH: null,
	CY: null,
	CZ: null,
	DE: null,
	DK: null,
	EE: null,
	ES: null,
	FI: null,
	FR: null,
	GB: null,
	GR: null,
	HR: null,
	HU: null,
	IC: null,
	IE: null,
	IT: null,
	LT: null,
	LU: null,
	LV: null,
	MT: null,
	NL: null,
	NO: null,
	PL: null,
	PT: null,
	RO: null,
	SE: null,
	SI: null,
	SK: null
};
export default {
	exchangeRates: exchangeRates
};
